import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";

const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/ojanzu/", icon: Facebook },
  { label: "Instagram", href: "https://www.instagram.com/ojanzu/", icon: Instagram },
  { label: "TikTok", href: "https://www.tiktok.com/@o_janzu", icon: null },
  { label: "YouTube", href: "https://www.youtube.com/channel/UCGiQB9sO6pSgJ5kh6HmO_QA", icon: Youtube },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/ojanzu", icon: Linkedin },
];

function TikTokIcon({ size = 17 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83V9.35a6.35 6.35 0 1 0 5.76 6.32V9.4a8.2 8.2 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.83z" />
    </svg>
  );
}

export default function SocialLinks({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="social-links">
      {SOCIALS.map((s) => (
        <a
          key={s.label}
          href={s.href}
          target="_blank"
          rel="noreferrer"
          title={s.label}
          aria-label={s.label}
          data-testid={`social-${s.label.toLowerCase()}`}
          className="grid h-10 w-10 place-items-center rounded-full border border-aqua/25 text-foam/70 transition-all duration-300 hover:border-aqua hover:bg-aqua/10 hover:text-aqua"
        >
          {s.icon ? <s.icon size={17} /> : <TikTokIcon />}
        </a>
      ))}
    </div>
  );
}
